(() => {
  'use strict';
  const init = (scope = document) => scope.querySelectorAll('[data-bn-auth]').forEach(root => {
    if (root.dataset.bnReady) return;
    root.dataset.bnReady = 'true';
    const login = root.querySelector('[data-bn-auth-login]'), recover = root.querySelector('[data-bn-auth-recover]');
    const show = (view, focus = false) => {
      if (!login || !recover) return;
      const recovery = view === 'recover'; login.hidden = recovery; recover.hidden = !recovery;
      if (focus) (recovery ? recover : login).querySelector('h1')?.focus();
    };
    if (location.hash === '#recover' || root.dataset.bnRecoverActive === 'true') show('recover');
    root.querySelectorAll('[data-bn-auth-view]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault(); const view = link.dataset.bnAuthView;
      history.replaceState(null, '', location.pathname + location.search + (view === 'recover' ? '#recover' : '#login')); show(view, true);
    }));
    window.addEventListener('hashchange', () => show(location.hash === '#recover' ? 'recover' : 'login'));
    root.querySelectorAll('[data-bn-password]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        const input = document.getElementById(button.dataset.bnPassword); if (!input) return;
        const visible = input.type === 'password'; input.type = visible ? 'text' : 'password';
        button.textContent = visible ? 'Ocultar' : 'Mostrar'; button.setAttribute('aria-label', visible ? 'Ocultar senha' : 'Mostrar senha'); button.setAttribute('aria-pressed', String(visible));
      });
    });
  });
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
